<template>
    <div>
        <h1>CONTOH AGENDA</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>